import { httpClient } from '../httpClient';

export const submissionsMethods = {
  // ── Spec 020 Wave D: submissions ledger + dual-signature ───────────────
  listSubmissions: (params) =>
    httpClient.get('/pdpl/submissions', { params }),

  getSubmission: (submissionId) =>
    httpClient.get(`/pdpl/submissions/${submissionId}`),

  initiateSubmission: (body) =>
    httpClient.post('/pdpl/submissions/initiate', body),

  coSignSubmission: (submissionId, body) =>
    httpClient.post(`/pdpl/submissions/${submissionId}/co-sign`, body),

  rejectCoSignSubmission: (submissionId, body) =>
    httpClient.post(`/pdpl/submissions/${submissionId}/co-sign-reject`, body),

  verifySubmission: (submissionId) =>
    httpClient.get(`/pdpl/submissions/${submissionId}/verify`),

  downloadSubmission: (submissionId) =>
    httpClient.get(`/pdpl/submissions/${submissionId}/download`),
};
